import { UserRole } from '../enums/UserRole'
import { AuthUser } from '../types/auth'
import ErrorMessage from '../types/ErrorMessage'
import { createSimpleErrorMessage, createSuperAdminErrorMessage } from './createError'

export function createUserNotification({
  user,
  type,
  error
}: {
  user: AuthUser
  type: string
  error: unknown
}): ErrorMessage {
  const message =
    user?.role === UserRole.SUPERADMIN
      ? createSuperAdminErrorMessage({
          type: type,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: error as any
        })
      : createSimpleErrorMessage({
          type: type,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: error as any
        })

  return message
}
